import React, { useEffect, useState } from "react";
import { MessageCircleMore } from "lucide-react";
import common from "../../../../utils/common";
import { useSelector } from "react-redux";

export default function SelectQuickMessageModal({
  isOpen,
  setIsOpen,
  content,
  files,
  setFiles,
  setContent,
  quickMessages,
  messageInputRef,
  contact,
}) {
  const auth = useSelector((state) => state.auth);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [filteredMessages, setFilteredMessages] = useState(quickMessages);

  // Handle keyboard events
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isOpen) {
        if (e.key === "/" && e.target === document.activeElement) {
          setIsOpen(true);
        }
        return;
      }

      switch (e.key) {
        case "ArrowUp":
          e.preventDefault();
          setSelectedIndex((prev) =>
            prev > 0 ? prev - 1 : filteredMessages.length - 1
          );
          break;
        case "ArrowDown":
          e.preventDefault();
          setSelectedIndex((prev) =>
            prev < filteredMessages.length - 1 ? prev + 1 : 0
          );
          break;
        case "Enter":
          e.preventDefault();
          if (filteredMessages[selectedIndex]) {
            setFiles([]);
            for (const url of filteredMessages[selectedIndex].images) {
              common
                .urlToBlob(url)
                .then((f) => setFiles((preFiles) => [...preFiles, f]));
            }
            setContent(
              common.replaceGender(
                common.replaceDatePlaceholders(
                  filteredMessages[selectedIndex].content
                    .replaceAll("#{FULL_NAME}", contact.name)
                    .replaceAll("#{ORIGINAL_NAME}", contact.zaloName)
                    .replaceAll("#{STAFF_NAME}", auth?.user?.name ?? "")
                ),
                contact.gender
              )
            );
            setIsOpen(false);
            messageInputRef.current.focus();
          }
          break;
        case "Escape":
          setIsOpen(false);
          break;
        default:
          break;
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, selectedIndex, filteredMessages]);

  // Handle message selection
  const handleSelectMessage = (message) => {
    setFiles([]);
    for (const url of message.images) {
      common
        .urlToBlob(url)
        .then((f) => setFiles((preFiles) => [...preFiles, f]));
    }
    setContent(
      common.replaceGender(
        common.replaceDatePlaceholders(
          message.content
            .replaceAll("#{FULL_NAME}", contact.name)
            .replaceAll("#{ORIGINAL_NAME}", contact.zaloName)
            .replaceAll("#{STAFF_NAME}", auth?.user?.name ?? "")
        ),
        contact.gender
      )
    );

    setIsOpen(false);
    messageInputRef.current.focus();
  };

  useEffect(() => {
    if (!content.startsWith("/")) return;

    const newQM = quickMessages.filter((qm) =>
      qm.shortcut.includes(content.slice(1))
    );
    setFilteredMessages(newQM);
  }, [content]);

  return (
    <div className="w-full max-w-2xl mx-auto">
      <div className="relative">
        {isOpen && (
          <div className="absolute bottom-full w-full mb-2 bg-white border rounded-lg shadow-lg">
            <div className="p-2 text-sm text-muted-foreground border-b">
              Nhấn Enter hoặc Click chuột để chọn mẫu câu, nhấn phím ↑ ↓ để điều
              hướng
            </div>
            <div className="max-h-[300px] overflow-y-auto">
              {filteredMessages.map((message, index) => (
                <div
                  key={message._id}
                  className={`flex items-center gap-3 p-3 cursor-pointer hover:bg-gray-200 ${
                    index === selectedIndex ? "bg-gray-200" : ""
                  }`}
                  onClick={() => handleSelectMessage(message)}
                >
                  <div className="text-muted-foreground">
                    <MessageCircleMore />
                  </div>
                  <div className="bg-muted text-muted-foreground px-2 py-0.5 rounded text-xs">
                    {message.shortcut}
                  </div>
                  <div className="flex-1 truncate text-sm">
                    {message.content}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
